import { useTranslation } from '@fareye/common'
import { valueColor } from '@fareye/configs'
import { Span } from '@fareye/ui'
import React from 'react'
import { latLng, Marker, Popup, Tooltip } from '@fareye/ui'
import { displayTime } from '../../../utility/function'
import FieldValue from './FieldValue'

export function ConsigneeMarker({ icon, data, selected, stopData }: any) {
  const { t } = useTranslation()
  const { inState: state, consigneeLat, consigneeLong, status, inState } =
    data || {}
  const [tempState, setState] = React.useState(0)

  const completedFlag = inState === 'completed'
  const { eta, ata, sta } = stopData || {}
  const { locationName: name, city } = data?.endLocation || {}
  function openPopup(marker: any) {
    if (marker && selected) {
      marker.leafletElement.openPopup()
    }
    if (marker && !selected) {
      marker.leafletElement.closePopup()
    }
  }

  return (
    <Marker
      position={latLng(consigneeLat, consigneeLong)}
      icon={icon}
      // ref={el => openPopup(el)}
      eventHandlers={{
        click: () => setState(tempState + 1)
      }}
    >
      <Tooltip direction="top" permanent offset={[10, -10]}>
        <strong>{t('Destination')}</strong> : {name}
      </Tooltip>
      <Popup>
        <Span variant="h6" style={{ marginBottom: 4 }}>
          {city}
        </Span>
        <Span variant="ellipsis secondary" style={{ marginBottom: 10 }}>
          {name}
        </Span>
        <FieldValue
          style={{ marginBottom: 4 }}
          labelStyle={{
            color: valueColor,
            fontWeight: 500
          }}
          label={t('Trip State')}
          value={t(state) || '-'}
        />
        {status ? (
          <FieldValue
            style={{ marginBottom: 15 }}
            labelStyle={{
              color: valueColor,
              fontWeight: 500
            }}
            label={`${t('Status')}${':'} `}
            value={t(status) || '-'}
          />
        ) : null}
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: valueColor }}
          label={t('STA')}
          value={sta?.time ? displayTime(sta) : ''}
        />
        <FieldValue
          style={{ marginBottom: 4 }}
          valueStyle={{ color: valueColor }}
          label={ata?.time || completedFlag ? t('ATA') : t('ETA')}
          value={
            ata?.time || completedFlag ? displayTime(ata) : displayTime(eta)
          }
        />
      </Popup>
    </Marker>
  )
}
